import { z } from "zod";
import { UserInfoLightSchema } from "./user-info-light.types";

/**
 * OpenAPI `NoteDisplay` — GET /{entity}/{id}/notes/{start}/{count}
 */
export const NoteDisplaySchema = z.object({
	id: z.string().uuid().nullable().optional(),
	text: z.string().nullable().optional(),
	createdAt: z.string().nullable().optional(),
	updatedAt: z.string().nullable().optional(),
	createdBy: UserInfoLightSchema.nullable().optional(),
});

export const NoteDisplayArraySchema = z.array(NoteDisplaySchema);

/**
 * Body for create / update note endpoints.
 */
export const CreateNoteInfoSchema = z.object({
	text: z.string().nullable().optional(),
});

/**
 * Query filters for entity note list / count endpoints.
 */
export const NoteParamsSchema = z.object({
	SearchTerm: z.string().optional(),
	IncludeDeleted: z.boolean().optional(),
	OrganizationId: z.string().optional(),
	SubOrganizationId: z.string().optional(),
	OrderBy: z
		.object({
			Fields: z.array(z.string()).optional(),
			Descending: z.boolean().optional(),
		})
		.optional(),
});

export type NoteDisplay = z.infer<typeof NoteDisplaySchema>;
export type CreateNoteInfo = z.infer<typeof CreateNoteInfoSchema>;
export type NoteParams = z.infer<typeof NoteParamsSchema>;

/** @deprecated Prefer {@link NoteParams}; kept for job call-site naming. */
export const JobNoteParamsSchema = NoteParamsSchema;
/** @deprecated Prefer {@link NoteParams}. */
export type JobNoteParams = NoteParams;
